import React from 'react';
import Draggable from 'react-draggable';
import dataTypes from '../../../assets/json/datenTypen.json';
import '../../../assets/styles/BRandRBBItem.css';
import {ChildrenBlur} from '../../../components/ChildrenBlur';
import TemperatureItem from './TemperatureItem';
import IconItem from './IconItem';
import ItemWrapper from './ItemWrapper';
import ItemMenuRBB from './ItemMenuRBB';

function calcPosition({position, size, mapScale, item}) {
  const iconScale = typeof item.ui.scale !== 'undefined' ? item.ui.scale : 1.0;

  const xPos = position.x * mapScale - (size.width * iconScale * mapScale) / 2;
  const yPos = position.y * mapScale - (size.height * iconScale * mapScale) / 2;

  return {
    x: xPos,
    y: yPos
  };
}

const MapItem = props => {
  const item = props.item;

  //LAYOUT

  const [, setPosition] = React.useState(props.initialPosition);

  const [locationLocked, setLocationLocked] = React.useState(true);

  const [, setHidden] = React.useState(props.hidden);

  const [, setDragged] = React.useState(false);
  const [, setIsFocusInElement] = React.useState(false);
  const [, setIsMouseInside] = React.useState(false);
  const [isRenderView, setIsRenderView] = React.useState(props.renderView);

  const valueKey = Object.keys(item.data)[1];
  const itemValue = item.inherited
    ? require('json-pointer').get(props.parentData, item.parent)
    : item.data[valueKey].value;
  // const itemValue = item.data[valueKey].value;
  if (item.inherited) {
    // const value =  require('json-pointer').get(props.parentData, item.parent)
    //  console.log(props.parentData)
    if (itemValue !== item.data[valueKey].value) {
      // console.log("A")
      item.data[valueKey].value = itemValue;
    }
  }
  const childRef = props.childRef;

  React.useEffect(() => {
    setHidden(props.hidden);
    setPosition(
      calcPosition({
        position: props.initialPosition,
        size: item.size,
        mapScale: props.mapScale,
        item
      })
    );
  }, [props.initialPosition, props.hidden, item, props.mapScale]);

  React.useImperativeHandle(childRef, () => ({
    check(state) {
      if (item.data.movable) {
        setLocationLocked(state);
      }
    },
    resetPosition() {
      resetPosition();
    },
    setRenderView(state) {
      setIsRenderView(state);
      if (item.data.movable && !locationLocked) {
        setLocationLocked(state);
      }
    }
  }));

  const resetPosition = () => {
    setPosition(
      calcPosition({
        position: item.data.defaultPosition,
        size: item.size,
        mapScale: props.mapScale,
        item
      })
    );
    props.setValueInMap(item, {x: {value: item.data.defaultPosition.x}});
    props.setValueInMap(item, {y: {value: item.data.defaultPosition.y}});
  };

  const onStart = () => {
    if (!locationLocked) setDragged(true);
  };
  const onStop = () => {
    if (!locationLocked) setDragged(false);
  };

  const dragHandlers = {onStart, onStop};

  const onControlledDrag = (e, position) => {
    if (locationLocked) {
      return;
    }
    setPosition(position);
  };

  const onControlledDragStop = (e, position) => {
    if (locationLocked) {
      return;
    }
    setPosition(position);
    const newX = position.x / props.mapScale + item.size.width * props.mapScale;
    const newY =
      position.y / props.mapScale + item.size.height * props.mapScale;
    props.setValueInMap(item, {x: {value: newX}});
    props.setValueInMap(item, {y: {value: newY}});

    onStop();
  };

  function generateIconUrl(itemValue) {
    return (
      item.ui.folder + item.ui.fileName + itemValue + item.ui.fileExtension
    );
  }

  let background;

  if (item.type === 'temperature') {
    background = (
      <TemperatureItem item={item}>
        {itemValue}
        {dataTypes[item.ui.unit].unit}
      </TemperatureItem>
    );
  } else {
    background = <IconItem item={item} imageUrl={generateIconUrl(itemValue)} />;
  }

  return (
    <Draggable
      {...dragHandlers}
      onStop={onControlledDragStop}
      onDrag={onControlledDrag}
      position={item.data.defaultPosition}
      disabled={!item.data.movable || locationLocked}>
      <ItemWrapper>
        <div
          style={{
            position: 'absolute'
          }}>
          {background}
        </div>

        {!isRenderView && (
          <ChildrenBlur
            onBlur={() => setIsFocusInElement(false)}
            onFocus={() => setIsFocusInElement(true)}
            onMouseLeave={() => setIsMouseInside(false)}
            onMouseEnter={() => setIsMouseInside(true)}>
            <ItemMenuRBB
              item={item}
              inherited={item.inherited}
              data={{key: valueKey, value: itemValue}}
              callback={props.setValueInMap}
              disabled={!locationLocked}
            />
          </ChildrenBlur>
        )}
      </ItemWrapper>
    </Draggable>
  );
};

export default MapItem;
